import { ConfigItem, ContractPriceItem, WebsiteItem } from '@/types'
import { MortisePrepFile, PreHangCartOptions, PreHangViewModel, SwingQuantity } from '@/types/preHang'
import { BaseHttpService } from './base-http-service'

class PreHangService extends BaseHttpService {
    async getOptions(item: ConfigItem | WebsiteItem | ContractPriceItem) {
        const result = await this.doApiPost<PreHangViewModel>(`/pre-hang-category/options`, { item })
        return result.response
    }

    async getPrice(item: ConfigItem | WebsiteItem | ContractPriceItem) {
        const result = await this.doApiPost<{price: number}>(`/pre-hang-category/price`, { item })
        return result.response!.price
    }

    getPreHangQuantity(options: PreHangCartOptions[], countDoubleDoorsTwice = true) {
        // Type change from object to array causes old options to error
        if (!Array.isArray(options)) {
            options = []
        }
        // Used when counting number of base door units versus number of prehang units.
        const dblDoorMultiplier = (countDoubleDoorsTwice) ? 2 : 1;

        return [
            ...((options ?? []).reduce((a, b) => [...a, ...(b.swingQuantities || [])], [] as SwingQuantity[]) ?? []).map(x => x.quantity),
            ...((options ?? []).reduce((a, b) => [...a, ...(b.doubleSwingQuantities || [])], [] as SwingQuantity[]) ?? []).map(x => x.quantity * dblDoorMultiplier),
            ...((options ?? []).reduce((a, b) => [...a, ...(b.machineSwingQuantities || [])], [] as SwingQuantity[]) ?? []).map(x => x.quantity),
            (options ?? []).filter(x => x.barnGroove).reduce((a, b) => a + (b.barnGrooveQuantity ?? 0), 0)
        ].reduce((a, b) => a + b, 0)
    }

    async uploadMortisePrep(fileElement: HTMLInputElement) {
        const result = await this.doFileUpload<{ fileName: string }>('/pre-hang-category/mortise-upload', 'template', fileElement)
        return result.response!.fileName
    }

    async downloadMortisePrep(file: MortisePrepFile) {
        const result = await this.downloadBinary(`/pre-hang-category/mortise-download/${file.fileName}`, 'application/pdf', undefined, file.displayName)
        return result.response
    }
}

export default function usePreHangService() {
    return new PreHangService()
}
